import React from 'react'
import {SGIcon} from "../component"

export const SGYTIcon = props => <SGIcon src={require("../assets/images/youtube-icon.png")} {...props}/>